// extracted by mini-css-extract-plugin
export var infoRow = "_rm-2";
export var labelContainer = "_rm-0";
export var rightInfo = "_rm-1";